var map = {
	"./brand.vue": 53055,
	"./calendar.vue": 91942,
	"./camera.vue": 51530,
	"./campaigns.vue": 78458,
	"./channel.vue": 61833,
	"./chat.vue": 63454,
	"./clear.vue": 41206,
	"./client.vue": 85569,
	"./close.vue": 12719,
	"./cluster.vue": 70479,
	"./config.vue": 42213,
	"./delete.vue": 83739,
	"./duplicate.vue": 1763,
	"./edit.vue": 59087,
	"./expand.vue": 21510,
	"./filter.vue": 60092,
	"./issue.vue": 97079,
	"./menu.vue": 93096,
	"./money.vue": 25148,
	"./next.vue": 83419,
	"./offline.vue": 52453,
	"./options.vue": 94324,
	"./place.vue": 86429,
	"./plus.vue": 11278,
	"./prev.vue": 65510,
	"./product.vue": 36718,
	"./register.vue": 85913,
	"./search.vue": 76788,
	"./sector.vue": 86377,
	"./send.vue": 25050,
	"./stats.vue": 35937,
	"./stock.vue": 57338,
	"./task.vue": 94602,
	"./user.vue": 94520,
	"./view.vue": 69843,
	"./worker.vue": 51511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14859;